import { Typography, Box } from '@mui/material';
import FormStep2Section1Container from 'containers/FormStep2Section1Container';
import FormStep2Section2Container from 'containers/FormStep2Section2Container';
import FormStep2Section3Container from 'containers/FormStep2Section3Container';
import { t } from 'i18next';

export default function WrapperForm2Section1to3() {
  return (
    <>
      <Typography color="surface.700" variant="h6">
        {t('step2.t&cTitle')}
      </Typography>
      <Box sx={{ my: 0.5 }}>
        <Typography color="surface.900" fontWeight="500" variant="body2">
          {t('step2.t&cDesc')}
        </Typography>
      </Box>
      <FormStep2Section1Container />
      <FormStep2Section2Container />
      <FormStep2Section3Container />
    </>
  );
}
